import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const ALLOWED_LANGUAGES = ['en', 'es', 'zh-hans', 'zh', 'ko']

export const useLanguage = () => {
  const { i18n } = useTranslation()
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const langParam = urlParams.get('lang')
    if (langParam && ALLOWED_LANGUAGES.includes(langParam)) {
      const lang = langParam === 'zh-hans' ? 'zh' : langParam
      i18n.changeLanguage(lang)
      return
    }
    const matches = window.location.href.match(/\/(\w+(?:-\w+)?)\//)
    if (matches && matches[1] && ALLOWED_LANGUAGES.includes(matches[1])) {
      const lang = matches[1] === 'zh-hans' ? 'zh' : matches[1]
      i18n.changeLanguage(lang)
    }
  }, [i18n])
  return null
}
